import { createContext, useState } from "react";

const TouchpointContext = createContext({});

export const initialSearchValues = {
  institutionId: null,
  quarterOfBudget: null,
  yearOfBudget: null,
  channel: null,
  groupsByAge: null,
  groupsByNationality: null,
  estateName: null,
};

export const initialPageValues = {
  page: 0,
  pageSize: 10,
  total: 0,
  totalPage: 0,
  sortBy: "createDate",
  sortDirection: "DESC",
};

export const TouchPointProvider = ({ children }) => {
  const [questionValues, setQuestionValues] = useState({
    questionId: "",
    channel: "",
    answer: "",
  });

  const [headerValues, setHeaderValues] = useState({
    id: "",
    quarter: undefined,
    position_reporter: "",
    name_reporter: "",
    tel_reporter: "",
    line_of_work: undefined,
    industrial_name: undefined,
    agency: undefined,
  });

  const [searchValues, setSearchValues] = useState(initialSearchValues);
  const [pageValues, setPageValues] = useState(initialPageValues);
  const [search, setSearch] = useState(true);

  return (
    <TouchpointContext.Provider
      value={{
        questionValues,
        setQuestionValues,
        headerValues,
        setHeaderValues,
        searchValues,
        setSearchValues,
        pageValues,
        setPageValues,
        search,
        setSearch,
      }}
    >
      {children}
    </TouchpointContext.Provider>
  );
};

export default TouchpointContext;
